// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Index from './pages/Index';
import About from './pages/About';
import Services from './pages/Services';
import Careers from './pages/Career';
import Contact from './pages/Contact';

import ScrollToTop from './components/ScrollToTop';
import RouteLoader from './components/RouteLoader';

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteLoader/> {/* ✅ clean loader */}

      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
